// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__wOuIr {
  display: flex;
  flex-direction: column;
  height: 100dvh;
}

.styles_action__houNv {
  width: 198px;
  height: 56px;
}

.styles_messages__\\+6jZC {
  width: 100%;
  height: 68dvh;
  padding-bottom: 0.15rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.styles_footer__E2Pts {
  width: 100%;
  height: 60px;
  position: relative;
}

.styles_input__2lBsq {
  width: 100%;
  height: 55px;
  padding: 0 48px 0 16px;
  border-radius: 12px;
  border: 2px solid var(--light-gray, #F3F5F7);
  background: var(--white, #FEFEFE);
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: #313333;
}
.styles_input__2lBsq:is(:active, :focus) {
  outline: none;
  box-shadow: 0 8px 24px 6px rgba(0, 0, 0, 0.06);
}
.styles_input__2lBsq::placeholder {
  color: var(--gray, #6C7275);
  font-size: 14px;
  font-style: normal;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.14px;
}

@media screen and (min-width: 640px) {
  .styles_action__houNv {
    width: 232px;
  }
}
@media screen and (min-width: 1024px) {
  .styles_action__houNv {
    width: 275px;
  }
}
@media screen and (min-height: 900px) {
  .styles_messages__\\+6jZC {
    height: 76dvh;
  }
}
@media screen and (min-height: 1024px) {
  .styles_messages__\\+6jZC {
    height: 80dvh;
  }
}
@media screen and (min-height: 1300px) {
  .styles_messages__\\+6jZC {
    height: 85dvh !important;
  }
}
@media screen and (min-height: 1080px) {
  .styles_messages__\\+6jZC {
    height: 80dvh;
  }
}
@media screen and (min-width: 1440px) {
  .styles_action__houNv {
    width: 305px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/styles.module.scss","webpack://./src/constants/fonts.scss","webpack://./src/constants/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,4CAAA;EACA,iCAAA;EAEA,kCCpCQ;EDqCR,gBAAA;EACA,cEvCM;AFoCR;AAKE;EACE,aAAA;EACA,8CAAA;AAHJ;AAME;EACE,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;AAJJ;;AASA;EACE;IACE,YAAA;EANF;AACF;AASA;EACE;IACE,YAAA;EAPF;AACF;AAUA;EACE;IACE,aAAA;EARF;AACF;AAWA;EACE;IACE,aAAA;EATF;AACF;AAYA;EACE;IACE,wBAAA;EAVF;AACF;AAaA;EACE;IACE,aAAA;EAXF;AACF;AAcA;EACE;IACE,YAAA;EAZF;AACF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n}\n\n.action {\n  width: 198px;\n  height: 56px;\n}\n\n.messages {\n  width: 100%;\n  height: 68dvh;\n  padding-bottom: 0.15rem;\n  margin-bottom: 1rem;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.footer {\n  width: 100%;\n  height: 60px;\n  position: relative;\n}\n\n.input {\n  width: 100%;\n  height: 55px;\n  padding: 0 48px 0 16px;\n  border-radius: 12px;\n  border: 2px solid var(--light-gray, #F3F5F7);\n  background: var(--white, #FEFEFE);\n\n  font-family: $poppins;\n  font-weight: 500;\n  color: $black;\n\n  &:is(:active, :focus){\n    outline: none;\n    box-shadow: 0 8px 24px 6px rgba(0, 0, 0, 0.06);\n  }\n\n  &::placeholder {\n    color: var(--gray, #6C7275);\n    font-size: 14px;\n    font-style: normal;\n    line-height: 24px; /* 171.429% */\n    letter-spacing: -0.14px;\n  }\n\n}\n\n@media screen and (min-width: 640px) {\n  .action {\n    width: 232px;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .action {\n    width: 275px;\n  }\n}\n\n@media screen and (min-height: 900px) {\n  .messages {\n    height: 76dvh;\n  }\n}\n\n@media screen and (min-height: 1024px) {\n  .messages {\n    height: 80dvh;\n  }\n}\n\n@media screen and (min-height: 1300px) {\n  .messages {\n    height: 85dvh !important;\n  }\n}\n\n@media screen and (min-height: 1080px) {\n  .messages {\n    height: 80dvh;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .action {\n    width: 305px;\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__wOuIr`,
	"action": `styles_action__houNv`,
	"messages": `styles_messages__+6jZC`,
	"footer": `styles_footer__E2Pts`,
	"input": `styles_input__2lBsq`
};
export default ___CSS_LOADER_EXPORT___;
